import { useAuth } from "../auth/AuthProvider";

export function UserBadge() {
  const { user, logout } = useAuth();
  if (!user) return null;
  const name = user.name ?? user.email ?? user.sub;
  return (
    <div className="user-badge">
      {user.picture && <img src={user.picture} alt="" width={32} height={32} referrerPolicy="no-referrer" />}
      <span>{name}</span>
      <button onClick={logout}>Sign out</button>
    </div>
  );
}
